module.exports = "../dist/img/product-detail-4-26.4fe2.jpg";